define('presentation/welcome/facades/onboardingDeliveryFacade',[
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'common/promises/promiseFactory',
    'persistence/webSocket/webSocketApp'
], function() {

    const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');
    const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

    let _promiseFactory = null;
    let _webSocketApp = null;

    const _getLiveReceptionistOnboarding = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.getLiveReceptionistOnboarding()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveMessageRecipients = (messageRecipients) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveMessageRecipients(messageRecipients)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveSmsRecipients = (smsRecipients) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveSmsRecipients(smsRecipients)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _startFreeTrial = () => {
        return _promiseFactory.deferIndefinitely((deferredObject) => {
            const liveReceptionistOnboardingRequest = {
                liveReceptionistOnboardingId: _liveReceptionistOnboardingState.liveReceptionistOnboardingId(),
                accountId: _sessionAccountInfo.accountId(),
                userId: _sessionAccountInfo.userId()
            };
            _webSocketApp.send("startFreeTrial", liveReceptionistOnboardingRequest, (result) => {
                deferredObject.resolve(result);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;

        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        _webSocketApp = new WebSocketAppConstructor();
        _webSocketApp.init("live_receptionist_onboarding");
    };

    return function() {
        let self = this;
        self.init = _init;

        self.getLiveReceptionistOnboarding = _getLiveReceptionistOnboarding;
        self.saveMessageRecipients = _saveMessageRecipients;
        self.saveSmsRecipients = _saveSmsRecipients;
        self.startFreeTrial = _startFreeTrial;
    };
});

